<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-2">
        <div class="side-heading">
          <h6>{{ $t("auth.Profile") }}</h6>
          <p class="font13 gray-col">{{ $t("auth.changePassMain") }}</p>
        </div>
      </div>
      <div class="card-details-def">
        <p class="font14 gray-col">{{ $t("auth.changePassHint") }}</p>
        <div class="col-md-7 col-12">
          <v-form @submit.prevent="changePassValid" v-model="valid" ref="form">
            <div class="main-input-cont mt-1">
              <h6 class="mb-2 font14 requiredInputLabel">{{ $t("auth.exPass") }}</h6>
              <v-text-field
                v-model="password"
                name="old_password"
                type="password"
                :rules="passwordRoles"
                :placeholder="$t('auth.exPassplace')"
              ></v-text-field>
              <div class="absLeft pointer-click" @click="toogleEyeIcon($event)">
                <div class="normalEye">
                  <i class="fa-regular fa-eye"></i>
                </div>
                <div class="slashedEye">
                  <i class="fa-regular fa-eye-slash"></i>
                </div>
              </div>
            </div>
            <div class="main-input-cont mt-1">
              <h6 class="mb-2 font14 requiredInputLabel">{{ $t("auth.newPass") }}</h6>
              <v-text-field
                v-model="newPassword"
                name="password"
                type="password"
                :rules="passwordRoles"
                :placeholder="$t('auth.passwordplace')"
              ></v-text-field>
              <div class="absLeft pointer-click" @click="toogleEyeIcon($event)">
                <div class="normalEye">
                  <i class="fa-regular fa-eye"></i>
                </div>
                <div class="slashedEye">
                  <i class="fa-regular fa-eye-slash"></i>
                </div>
              </div>
            </div>
            <div class="main-input-cont mt-1">
              <h6 class="mb-2 font14 requiredInputLabel">{{ $t("auth.passwordconfirm") }}</h6>
              <v-text-field
                v-model="confirmPassword"
                name="password_confirmation"
                type="password"
                :rules="confirmRules"
                :placeholder="$t('auth.passwordplace')"
              ></v-text-field>
              <div class="absLeft pointer-click" @click="toogleEyeIcon($event)">
                <div class="normalEye">
                  <i class="fa-regular fa-eye"></i>
                </div>
                <div class="slashedEye">
                  <i class="fa-regular fa-eye-slash"></i>
                </div>
              </div>
            </div>
            <div class="flex-sm-gap mb-3">
              <button
                type="submit"
                :disabled="disabled"
                class="main-btn up w-100 mt-4 xl"
              >
                <div v-if="!disabled">{{ $t("auth.confirm") }}</div>
                <div class="loading" role="status" v-if="disabled">
                  {{ $t("auth.confirming") }}
                  <div class="spinner-small-white" v-if="disabled"></div>
                </div>
              </button>
            </div>
          </v-form>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";

import { ref, onMounted } from "vue";
// import ChangePassword from "./changePassword.vue";
import axios from "axios";
import { useToast } from "primevue/usetoast";
import { useRouter } from "vue-router";
const toast = useToast();
const router = useRouter();
import i18n from "@/i18n";

// reactive state

const valid = ref(false);
const disabled = ref(false);
const form = ref(null);
const password = ref("");
const newPassword = ref("");
const confirmPassword = ref("");

const passwordRoles = ref([
  (value) => {
    if (value) return true;

    return i18n.global.t(`auth.passValid`);
  },
]);
const confirmRules = ref([
  (value) => {
    if (value) return true;
    return i18n.global.t(`auth.passValid`);
  },
  (value) => {
    if (value === newPassword.value) return true;
    
    return i18n.global.t(`auth.passValidId`);
  },
]);

// functions
function toogleEyeIcon(event) {
  console.log(event.currentTarget);
  event.currentTarget.classList.toggle("toggleEye");
  let currentType = event.currentTarget.previousElementSibling
    .querySelector("input")
    .getAttribute("type");
  console.log(currentType);
  if (currentType == "text") {
    event.currentTarget.previousElementSibling
      .querySelector("input")
      .setAttribute("type", "password");
  } else {
    event.currentTarget.previousElementSibling
      .querySelector("input")
      .setAttribute("type", "text");
  }
}

function changePassValid() {
  if (valid.value) {
    ChangePassword();
  }
}

function ChangePassword() {
  disabled.value = true;
  const fd = new FormData(form.value.$el);

  axios
    .post("/manager/update-passward?_method=patch", fd, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      if (response.data.key == "success") {
        console.log(response.data);
        toast.add({
          severity: "success",
          detail: `${response.data.msg}`,
          life: 3000,
        });
        router.push("/dashboardHome");
      } else {
        toast.add({
          severity: "error",
          detail: `${response.data.msg}`,
          life: 3000,
        });
      }
      disabled.value = false;
    });
}
// lifecycle hooks
onMounted(() => {
  // console.log(`mounted`);
});
</script>
